import { Ticker } from 'pixi.js';

export class Util {
  private static tickers: Ticker[] = [];

  /**
   * Wait for specified time
   * @param milliseconds 指定時間
   */
  public static async wait(milliseconds: number): Promise<void> {
    return new Promise((resolve, reject) => {
      const ticker = new Ticker();
      this.tickers.push(ticker);
      let totalElapsed = 0;
      ticker.add(() => {
        // interrupt
        const tickerIndex = this.tickers.indexOf(ticker);
        if (tickerIndex < 0) {
          ticker.destroy();
          reject();
          return;
        }
        // finish
        totalElapsed += ticker.elapsedMS;
        if (totalElapsed >= milliseconds) {
          ticker.destroy();
          this.tickers.splice(tickerIndex, 1);
          resolve();
        }
      });
      ticker.start();
    });
  }

  /**
   * Wait until meet the conditions
   * @param predicate predicate
   */
  public static async waitUntil(predicate: () => boolean): Promise<void> {
    return new Promise((resolve, reject) => {
      const ticker = new Ticker();
      this.tickers.push(ticker);
      ticker.add(() => {
        // interrupt
        const tickerIndex = this.tickers.indexOf(ticker);
        if (tickerIndex < 0) {
          ticker.destroy();
          reject();
          return;
        }
        // finish
        if (predicate()) {
          ticker.destroy();
          this.tickers.splice(tickerIndex, 1);
          resolve();
        }
      });
      ticker.start();
    });
  }

  /**
   * Wait while meet the conditions
   * @param predicate predicate
   */
  public static async waitWhile(predicate: () => boolean): Promise<void> {
    return this.waitUntil(() => {
      return !predicate();
    });
  }

  /**
   * Kill wait timer
   */
  public static killWait(): void {
    this.tickers = [];
  }
}
